<template>
  <v-card elevation="0" height="100%" class="overflow-hidden">
    <v-card-title style="width: 100%">
      <v-btn v-if="Object.keys(list_comments).length > 0" icon @click="closeWindowEstimation">
        <v-icon size="15px">
          fa-chevron-left
        </v-icon>
      </v-btn>
      Составление оценочного листа
    </v-card-title>
    <v-card-text style="height: calc(100% - 125px);" class="mt-2 overflow-auto">
      <v-card elevation="0" class="overflow-hidden rounded-xl" outlined>
        <v-data-table
            :headers="headers_table_annotation"
            :items="data_table"
            :expanded.sync="expanded"
            :single-expand="true"
            item-key="parameter_name"
            show-expand
            height="100%"
            mobile-breakpoint="0"
            hide-default-footer
            outlined
        >
          <template v-slot:header.data-table-expand="{ header }">
            <v-icon
                :color="color_all_confirm"
                @click="confirmAllParameters()"
                size="15px"
            >
              fa-thumbs-up
            </v-icon>
          </template>
          <template v-slot:item.index="{ item }">
            {{ setIndexParent(item) }}
          </template>
          <template v-slot:item.estimation_section="{ item }">
            <div class="d-flex justify-center">
              <v-menu
                  rounded="lg"
                  offset-y
                  left
                  origin="top right"
                  transition="scale-transition"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      x-small
                      icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon
                        size="15px"
                    >
                      fa-ellipsis-v
                    </v-icon>
                  </v-btn>
                </template>
                <v-list class="ma-0">
                  <v-list-item
                      @click="externalMenuMethods(menu_item, item)"
                      link
                      dense
                      class="px-0"
                      v-for="(menu_item, index) in external_menu" :key="index"
                  >
                    <v-list-item-avatar class="ma-0">
                      <v-icon class="d-flex align-center" small :color="menu_item.color">
                        {{ menu_item.icon }}
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title class="pr-2">{{ menu_item.name }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>
          <template v-slot:item.status_estimation_global="{ item }">
            <v-icon :color="setGlobalStatus(item).color" small>
              {{ setGlobalStatus(item).icon }}
            </v-icon>
          </template>
          <template v-slot:item.data-table-expand="{ isExpanded, expand, item }">
            <v-icon
                v-if="item.content.length > 0"
                :class="isExpanded ? 'rotate-chevron-u' : ''"
                @click="isExpanded ? expand(active_expand) : expand(!active_expand)"
                size="15px"
            >
              fa-chevron-down
            </v-icon>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="pa-0 white">
              <v-card class="overflow-hidden pa-5" width="100%" elevation="0">
                <v-card outlined class="rounded-xl">
                  <v-data-table
                      :headers="headers_table_inner"
                      :items="item.content"
                      no-data-text="Данные курса отсутствуют"
                      item-key="id"
                      height="100%"
                      mobile-breakpoint="0"
                      hide-default-footer
                      outlined
                  >
                    <template v-slot:item.index="{ item }">
                      {{ setIndexChild(item) }}
                    </template>
                    <template v-slot:item.status_estimation="{ item }">
                      <v-icon :color="setStatus(item.status_estimation).color" small>
                        {{ setStatus(item.status_estimation).icon }}
                      </v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <div class="d-flex justify-center">
                        <v-menu
                            rounded="lg"
                            offset-y
                            left
                            origin="top right"
                            transition="scale-transition"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                x-small
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                              <v-icon
                                  size="15px"
                              >
                                fa-ellipsis-v
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list class="ma-0">
                            <v-list-item
                                @click="innerMenuMethods(menu_item, item)"
                                link
                                dense
                                class="px-0"
                                v-for="(menu_item, index) in external_menu" :key="index"
                            >
                              <v-list-item-avatar class="ma-0">
                                <v-icon class="d-flex align-center" small :color="menu_item.color">
                                  {{ menu_item.icon }}
                                </v-icon>
                              </v-list-item-avatar>
                              <v-list-item-title class="pr-2">{{ menu_item.name }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </template>
                  </v-data-table>
                </v-card>
              </v-card>
            </td>
          </template>
        </v-data-table>
        <DialogSetComments
            :comment_dialog_visible="comment_dialog_visible"
            :current_item="current_item"
            @setComment="setComment($event)"
            @CommentDialogClose="CommentDialogClose"
        />
      </v-card>
      <v-checkbox v-model="checkbox_addit_message">
        <template v-slot:label>
          <div>
            Оставить дополнительно комментарий
          </div>
        </template>
      </v-checkbox>
      <v-slide-x-transition>
        <v-textarea
            class="rounded-xl"
            v-model="addit_message"
            v-if="checkbox_addit_message"
            outlined
            auto-grow
            rows="7"
            name="input-7-4"
            label="Дополнительно"
        >
        </v-textarea>
      </v-slide-x-transition>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="6">
          <v-btn
              @click="rejection(selected_tech_map)"
              elevation="0"
              rounded
              block
              small
              outlined
              color="red"
          >
            Отклонить
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              @click="approvement(selected_tech_map)"
              elevation="0"
              rounded
              small
              block
              outlined
              color="green"
          >
            Подтвердить
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import {mapActions, mapState} from "vuex";
import DialogSetComments from "../EditDialogs/DialogSetComments.vue";

export default {
  name: "CardEstimationMethodologist",
  components: {DialogSetComments},
  props: {
    selected_tech_map: {
      type: Object
    }
  },
  data: () => ({
    approve: false,
    reject: false,
    headers_table_annotation: [
      {text: '№', value: 'index', sortable: false, align: "center", filterable: false, divider: true},
      {text: 'Параметр', value: 'parameter_name', sortable: false, align: "start", filterable: false, divider: true},
      {
        text: 'Общий статус',
        value: 'status_estimation_global',
        align: "center",
        sortable: false,
        filterable: false,
        divider: true
      },
      {
        text: 'Комментрий',
        value: 'comments',
        align: "center",
        sortable: false,
        filterable: false,
        divider: true
      },
      {
        text: 'Оценить раздел',
        value: 'estimation_section',
        sortable: false,
        align: "center",
        filterable: false,
        divider: true
      },
      {text: '', value: 'data-table-expand'},
    ],
    headers_table_inner: [
      {text: '№', value: 'index', sortable: false, align: "center", filterable: false, divider: true},
      {text: 'Элемент', value: 'name', sortable: false, align: "start", filterable: false, divider: true},
      {text: 'Наличие', value: 'status_estimation', align: "center", sortable: false, filterable: false, divider: true},
      {text: 'Комментарий', value: 'comments', align: "center", sortable: false, filterable: false, divider: true},
      {text: 'Действия', value: 'actions', align: "center", sortable: false, filterable: false},
    ],
    expanded: [],
    active_expand: false,
    data_table: [],
    default_data_table: [
      {
        parameter_name: "Аннотация ЭУК",
        content: [
          {id: 1, name: "Название курса", status_estimation: 1, comments: ''},
          {id: 2, name: "Цель курса", status_estimation: 1, comments: ''},
          {id: 3, name: "Задачи курса", status_estimation: 1, comments: ''},
          {id: 4, name: "Категория обучаемых", status_estimation: 1, comments: ''},
          {id: 5, name: "Планируемые результаты обучения", status_estimation: 1, comments: ''},
          {id: 6, name: "Срок освоения курса", status_estimation: 1, comments: ''},
          {id: 7, name: "Формат реализации дисциплины", status_estimation: 1, comments: ''},
          {id: 8, name: "Форма промежуточной аттестации", status_estimation: 1, comments: ''},
          {id: 9, name: "Преподаватель, автор курса", status_estimation: 1, comments: ''},
        ],
        status_estimation_global: 1,
        comments: ''
      },
      {
        parameter_name: "Вводный модуль",
        content: [
          {id: 10, name: "Название курса", status_estimation: 1, comments: ''},
          {id: 11, name: "Вступительное слово (видео обращение)", status_estimation: 1, comments: ''},
          {id: 12, name: "Контактная информация", status_estimation: 1, comments: ''},
          {id: 13, name: "Объявления, чат, форум", status_estimation: 1, comments: ''},
          {
            id: 14,
            name: "Методические рекомендации, указания, инструкции для слушателей по работе с материалами ЭУК",
            status_estimation: 1,
            comments: ''
          },
          {id: 15, name: "Рабочая программа", status_estimation: 1, comments: ''},
          {id: 16, name: "Анкета входного контроля по дисциплине", status_estimation: 1, comments: ''},
        ],
        status_estimation_global: 1,
        comments: ''
      },
      {
        parameter_name: "Тематический модуль",
        content: [
          {id: 17, name: "Лекции", status_estimation: 1, comments: ''},
          {id: 18, name: "Практические занятия", status_estimation: 1, comments: ''},
          {id: 19, name: "Лабораторная работа", status_estimation: 1, comments: ''},
          {id: 20, name: "Самостоятельная работа студента", status_estimation: 1, comments: ''},
          {id: 21, name: "Курсовая работа/проект", status_estimation: 1, comments: ''},
          // {id: 22, name: "Консультации", status_estimation: 1, comments: ''},
        ],
        status_estimation_global: 1,
        comments: ''
      },
      {
        parameter_name: "Содержательное наполнение модуля «Модуль промежуточной аттестации»",
        status_estimation_global: 1,
        content: [],
        comments: ''
      },
      {
        parameter_name: "Содержательное наполнение модуля «Модуль оценки качества»",
        status_estimation_global: 1,
        content: [],
        comments: ''
      }
    ],
    inner_menu: [
      // {icon: "fa fa-check-circle", color: "green", name: "Да", key: 1},
      // {icon: "fa fa-times", color: "red", name: "Нет", key: 2},
      {icon: "fa fa-comments", color: "grey", name: "Комментарий", key: 3},
    ],
    external_menu: [
      // {icon: "fa fa-check-circle", color: "green", name: "Одобрить", key: 1},
      // {icon: "fa fa-times", color: "red", name: "Отклонить", key: 2},
      {icon: "fa fa-comments", color: "grey", name: "Комментарий", key: 3},
    ],
    checkbox_addit_message: false,
    addit_message: '',
    comment_dialog_visible: false,
    text_curr_comment: '',
    current_item: {},
    color_all_confirm: 'grey'
  }),
  mounted() {
    this.data_table = _.cloneDeep(this.default_data_table)
  },
  watch: {
    data_table: {
      handler(){
        let count_parameters = this.data_table.length
        let counter = 0

        this.data_table.forEach((parent_el) => {
          if (parent_el.status_estimation_global === 2){
            counter += 1
          }
        })

        if (count_parameters === counter) this.color_all_confirm = 'green'
        else this.color_all_confirm = 'grey'
      },
      deep: true
    },
  },
  computed: {
    ...mapState({
      list_comments: state => state.studyEstEukTechMapCommission.list_comments,
    }),
  },
  methods: {
    ...mapActions({
      updateCommissionStatus: 'studyEstEukTechMapCommission/updateCommissionStatus',
    }),
    rejection(selected_tech_map) {
      let commission_status = {
        role_key: 3,
        technological_map_id: selected_tech_map.id,
        status_review: 3,
        data_comment: this.data_table,
        addit_message: this.addit_message
      }
      this.updateCommissionStatus(commission_status).then(() => {
        this.closeWindowEstimation()
        this.setDefaultDataCommission()
      })
    },
    approvement(selected_tech_map) {
      let commission_status = {
        role_key: 3,
        technological_map_id: selected_tech_map.id,
        status_review: 2,
        data_comment: this.data_table,
        addit_message: this.addit_message
      }
      this.updateCommissionStatus(commission_status).then(() => {
        this.closeWindowEstimation()
        this.setDefaultDataCommission()
      })
    },
    setDefaultDataCommission() {
      this.checkbox_addit_message = false
      this.data_table = _.cloneDeep(this.default_data_table)
      this.addit_message = ''
    },
    setGlobalStatus(item_annotation){
      if (item_annotation.status_estimation_global === 2) return {color: 'green', icon: 'fa fa-check-circle'}
      if (item_annotation.status_estimation_global === 3) return {color: 'red', icon: 'fa fa-times-circle'}

      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    setStatus(status_estimation) {
      if (status_estimation === 2) {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (status_estimation === 3) {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
      return {color: 'orange', icon: 'fa fa-exclamation-circle'}
    },
    updateGlobalStatus(index_parent){
      let count_statuses_conf = 0
      let count_statuses_reject = 0

      this.data_table[index_parent].content.forEach((el)=> {
        if (el.status_estimation === 2){
          count_statuses_conf += 1
        }
        if (el.status_estimation === 3){
          count_statuses_reject += 1
        }
      })

      if (count_statuses_conf === this.data_table[index_parent].content.length) {
        this.data_table[index_parent].status_estimation_global = 2
      }
      else if (count_statuses_reject === this.data_table[index_parent].content.length) {
        this.data_table[index_parent].status_estimation_global = 3
      }
      else this.data_table[index_parent].status_estimation_global = 1
    },
    innerMenuMethods(menu_item, children_item) {
      let index_parent = _.findIndex(this.data_table, ['parameter_name', this.expanded[0].parameter_name])
      let children_element = _.find(this.data_table[index_parent].content, ['name', children_item.name])

      if (menu_item.key === 1) {
        children_element.status_estimation = 2
        this.updateGlobalStatus(index_parent)
      } else if (menu_item.key === 2){
        children_element.status_estimation = 3
        this.updateGlobalStatus(index_parent)
      } else {
        this.current_item = children_item
        this.comment_dialog_visible = true
      }
    },
    externalMenuMethods(menu_item, parent_item) {
      let index_parent = _.findIndex(this.data_table, ['parameter_name', parent_item.parameter_name])

      switch (menu_item.key) {
        case(1):
          if (this.data_table[index_parent].content.length > 0){
            this.data_table[index_parent].content.forEach((children_element) => {
              children_element.status_estimation = 2
            })
          }
          this.data_table[index_parent].status_estimation_global = 2
          break
        case(2):
          if (this.data_table[index_parent].content.length > 0){
            this.data_table[index_parent].content.forEach((children_element) => {
              children_element.status_estimation = 3
            })
          }
          this.data_table[index_parent].status_estimation_global = 3
          break
        case(3):
          this.current_item = parent_item
          this.comment_dialog_visible = true
      }
    },
    setComment(props){
      if (this.current_item.hasOwnProperty("content")) {
        let index_parent = _.findIndex(this.data_table, ['parameter_name', this.current_item.parameter_name])

        this.data_table[index_parent].comments = props.comments
      } else {
        let index_parent = _.findIndex(this.data_table, ['parameter_name', this.expanded[0].parameter_name])
        let children_element = _.find(this.data_table[index_parent].content, ['name', this.current_item.name])

        children_element.comments = props.comments
      }
      this.CommentDialogClose()
    },
    setIndexParent(parent_item) {
      let index_parent = _.findIndex(this.data_table, ['parameter_name', parent_item.parameter_name])

      return index_parent + 1
    },
    setIndexChild(child_item) {
      let index_parent = _.findIndex(this.data_table, ['parameter_name', this.expanded[0].parameter_name])
      let children_element = _.findIndex(this.data_table[index_parent].content, ['name', child_item.name])

      children_element += 1
      index_parent += 1

      return index_parent + "." + children_element
    },
    closeWindowEstimation() {
      this.$emit('closeWindowEstimation')
    },
    CommentDialogClose(){
      this.comment_dialog_visible = false
    },
    confirmAllParameters(){
      this.data_table.forEach((parent_el) => {
        if (parent_el.status_estimation_global === 2) {
          parent_el.status_estimation_global = 1
        } else if (parent_el.status_estimation_global === 1){
          parent_el.status_estimation_global = 2
        }

        parent_el.content.forEach((children_element) => {
          if (children_element.status_estimation === 2 && children_element.comments === 'Да'){
            children_element.status_estimation = 1
            children_element.comments = ''
          } else if (children_element.status_estimation === 1 && children_element.comments === ''){
            children_element.status_estimation = 2
            children_element.comments = 'Да'
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.v-data-table >>> .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none;
}
.rotate-chevron-u {
  transform:rotate(180deg) ;
}
</style>